import { render, staticRenderFns } from "./ModalConfirmRejection.vue?vue&type=template&id=1ad8ba8d&"
import script from "./ModalConfirmRejection.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmRejection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports